module.exports = __webpack_public_path__ + "img/9788970638324.49750f09.jpg";